import DefaultLayout from '../layout/DefaultLayout';
import Breadcrumb from '../components/Breadcrumbs/Breadcrumb.tsx';
import TeacherSchedule from "../components/Schedule/TeacherSchedule.tsx";


const Protocols = () => {
    return (
        <DefaultLayout>
            <Breadcrumb pageName="Schedule" />
            <TeacherSchedule/>
        </DefaultLayout>
    );
};

export default Protocols;
